import React, { useState } from 'react';
import { IconButton, Snackbar, Tooltip } from '@mui/material';
import { FileCopy as FileCopyIcon } from '@mui/icons-material';
import CopyToClipboard from 'react-copy-to-clipboard';

const ClipboardComponent = ({ textToCopy }) => {
  const [isAlertOpen, setAlertOpen] = useState(false);

  const handleCopy = () => {
    // Do something after text is copied if needed
    console.log('Text copied to clipboard!');

    // Show the alert
    setAlertOpen(true);
  };

  const handleCloseAlert = () => {
    // Hide the alert
    setAlertOpen(false);
  };

  return (
    <div>
      <CopyToClipboard text={textToCopy} onCopy={handleCopy}>
        <IconButton color="primary" onClick={() => {}} size="large">
          <Tooltip title={"Copy to Clipboard"}>
              <FileCopyIcon />
          </Tooltip>
        </IconButton>
      </CopyToClipboard>

      {/* Snackbar for alert */}
      <Snackbar
        open={isAlertOpen}
        autoHideDuration={2000} // Adjust as needed
        onClose={handleCloseAlert}
        message="Text copied to clipboard!"
      />
    </div>
  );
};

export default ClipboardComponent;
